// Inline per-field validation message, rendered directly under the
// offending control (BACKLOG.md Batch 1) - shared by LineItemsEditor.jsx
// and CategorySelectCell.jsx (extracted to its own file, not duplicated,
// to avoid a circular import between the two - Item 4b, 2026-07-21).
const FieldError = ({ message }) => {
  if (!message) return null;
  return <p className="text-[10px] text-red-600 mt-0.5 leading-tight">{message}</p>;
};

export default FieldError;
